import { render, staticRenderFns } from "./ReportDownloadHQ.vue?vue&type=template&id=85620cd4&scoped=true"
import script from "./ReportDownloadHQ.vue?vue&type=script&lang=js"
export * from "./ReportDownloadHQ.vue?vue&type=script&lang=js"
import style0 from "./ReportDownloadHQ.vue?vue&type=style&index=0&id=85620cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85620cd4",
  null
  
)

export default component.exports